import "./index.scss";
import initForm from "../../js/forms";
import tooltipGuidance from "../../js/forms/guidance";
import {hideLoader, setLoaderState, showLoader} from "../../js/loader";
import runWorkFlow from "../../js/automation";
import {setLocation} from "../../js/network";
import debug from "../../js/debug";
import {requestPasswordRecovery} from "../../js/api/password_recovery";

// Password recovery errors workflows
const passwordRecoveryErrorsWorkflows = {
  "ERR_UNKNOWN": [
    {
      "function": setLoaderState,
      "params": ["error", ["Password Recovery Failed", "We're experiencing some errors", "Please Try Again Later"]],
      "delay": 1500,
    },
    {
      "function": hideLoader,
      "delay": 4500,
    },
  ],
  "ERR_EMAIL_UNRECOGNIZED":
    [
      {
        "function": setLoaderState,
        "params": ["error", ["Error", "Unrecognized Email", "Please Review Input"]],
        "delay": 1500,
      },
      {
        "function": hideLoader,
        "delay": 4500,
      },
    ],
  "ERR_EMAIL_MISSING": [
    {
      "function": setLoaderState,
      "params": ["error", ["Error", "E-mail Missing", "Please Review Input"]],
      "delay": 3000,
    },
    {
      "function": hideLoader,
      "delay": 4500,
    },
  ],
  "ERR_EMAIL_MALFORMATTED": [
    {
      "function": setLoaderState,
      "params": ["error", ["Error", "E-mail Malformatted", "Please Review Input"]],
      "delay": 3000,
    },
    {
      "function": hideLoader,
      "delay": 4500,
    },
  ],
};

// Main functionality
window.addEventListener("DOMContentLoaded", () => {
  // Initialize form
  initForm(
    document.getElementById("password_recovery_form"),
    {
      formControl: document.getElementById("bttnLandingRecover"),
      fieldsValidators: {
        "emailAddress": {
          "required": true,
          "re": /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
          "guidance": tooltipGuidance.emailAddress,
          "formId": ["password_recovery_form"],
        },
      },
      successCallback: form => {
        // Show loader
        showLoader();
        setLoaderState("animating", ["Sending Recovery Email..."]);
        // Requesting password recovery
        requestPasswordRecovery(form.querySelector("#emailAddress").value.trim())
          .then(() => {
            runWorkFlow([
              {
                "function": setLoaderState,
                "params": ["success", ["Recovery Email Sent"]],
                "delay": 1500,
              },
              {
                "function": setLoaderState,
                "params": ["welcome", ["Check Your Inbox"]],
                "delay": 1500,
              },
              {
                "function": setLocation,
                "params": [publicPath + "/login"],
                "delay": 4500,
              },
            ]);
          })
          .catch(error => {
            debug(
              ["🐛 %cpassword-recovery ~ initForm ~ successCallback", "font-weight:bold"],
              "Error when requesting password reset 👉",
              error,
              "👈",
            );
            const messages = (!error.response || !error.response.data || !error.response.data.message ||
              !error.response.data.message.length) ? ["ERR_UNKNOWN"] : error.response.data.message;
            messages.forEach(m => {
              if (!passwordRecoveryErrorsWorkflows[m]) {
                return;
              }
              runWorkFlow(passwordRecoveryErrorsWorkflows[m]);
            });
          });
      },
    },
  );
});
